<template>
  <div class="details">
    <div class="details__title">商品详情</div>
    <div class="details__tips">
      温馨提示：部分商品包装更换频繁，如货品与图片不完全一致，请以收到的商品实物为准。如页面存在有效期信息，为库存产品最近有效期，实际产品有效期以到货产品有效期为准。如发现商品存在质量问题，请拨打智云集团质量投诉专线电话：400-9216-690
    </div>
    <div class="details__table" v-if="descripArr.length">
      <div class="details__table__tr" v-for="item in descripArr" :key="item.key">
        <div class="details__table__td min__width">{{ item.label }}：</div>
        <div v-if="item.key === 'spec'" class="details__table__td">{{ item.value }}/{{ goodsInfo.packageUnit }}</div>
        <div v-else class="details__table__td">
          {{ item.value }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    goodsInfo: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    goodsInfo() {
      this.descripArr = [];
      this.init();
    }
  },
  data() {
    return {
      labelKey: [
        { key: 'itemName', label: '商品名称' },
        { key: 'productDate', label: '生产日期' },
        { key: 'spec', label: '规格包装' },
        { key: 'expirationDate', label: '有效期至' },
        { key: 'productFactoryName', label: '生产厂家' },
        { key: 'approval', label: '批准文号' },
        { key: 'indication', label: '功能主治' },
        { key: 'ingredient', label: '主要成分' },
        { key: 'usage', label: '用法用量' },
        { key: 'adverseReaction', label: '不良反应' },
        { key: 'attention', label: '注意事项' },
        { key: 'contraindication', label: '禁忌' },
        { key: 'prescriptionFlag', label: '是否处方药', type: 'boolean' },
        { key: 'reagentType', label: '剂型' },
        { key: 'itemRemark', label: '商品备注' }
      ],
      descripArr: []
    };
  },
  methods: {
    init() {
      let resultArr = [];
      this.labelKey.map(item => {
        resultArr.push({
          ...item,
          value: item.type == 'boolean' ? (this.goodsInfo[item.key] ? '是' : '否') : this.goodsInfo[item.key]
        });
      });
      this.descripArr = resultArr.filter(item => !!item.value);
    }
  },
  created() {
    this.init();
  }
};
</script>

<style lang="scss" scoped>
.details {
  &__title {
    padding: 12px;
    font-size: 14px;
    font-weight: 400;
    color: #262626;
    line-height: 1;
    background: #f4f4f4;
  }
  &__tips {
    margin-top: 4px;
    padding: 12px 16px;
    font-size: 14px;
    font-weight: 400;
    color: #fd8309;
    line-height: 22px;
    background: #fcf8e6;
  }
  &__table {
    display: table;
    border-collapse: separate;
    margin-bottom: 16px;
    padding: 16px;
    font-size: 14px;
    font-weight: 400;
    color: #595959;
    line-height: 1.5;
    &__tr {
      // display: table-row;
      margin-bottom: 24px;
    }
    &__td {
      display: table-cell;
    }
    .min__width {
      color: #8c8c8c;
      white-space: nowrap;
    }
  }
}
</style>
